export const ManagementItems = [{
    href: '/rebalanceSetting/dashboard',
    title: '首頁',
    icon: 'fa-home',
    regex: /rebalanceSetting\/dashboard/,
    auth: 'dashboard',
},
{
    title: '會員相關',
    icon: 'fa-users',
    regex: /\/logRecord/,
    auth: '會員相關',
    children: [
        {
            href: '/rebalanceSetting/member',
            title: '客戶列表',
            icon: 'fa-users',
            regex: /rebalanceSetting\/member/,
            auth: '客戶列表'
        },
        {
            href: '/rebalanceSetting/article',
            title: '文章列表',
            icon: 'fa-picture-o',
            regex: /rebalanceSetting\/article/,
            auth: '文章列表'
        },
    ]
},
    {
        title: '設定相關',
        icon: 'fa-cog',
        regex: /\/logRecord/,
        auth: '設定相關',
        children: [
            {
                href: '/rebalanceSetting',
                title: '模板設定',
                icon: 'fa-heart-o',
                regex: /rebalanceSetting/,
                auth: '模板設定'
            },
            {
                href: '/rebalanceSetting/favorite',
                title: '我的最愛',
                icon: 'fa-heart-o',
                regex: /rebalanceSetting\/favorite/,
                auth: '我的最愛'
            },
            {
                href: '/rebalanceSetting/guide',
                title: '新手導覽',
                icon: 'fa-heart-o',
                regex: /rebalanceSetting\/guide/,
                auth: '新手導覽'
            },
        ]
    },

]



// {
//     href: '/production',
//     title: '產品',
//     icon: 'lnr.lnr-license',
//     regex: /\/production/,
//     auth: '產品'
// },
// {
//     href: '/customer',
//     title: '聯絡我們',
//     icon: 'lnr.lnr-envelope',
//     regex: /\/customer/,
//     auth: '聯絡我們'
// },

// {
//     href: '/account',
//     title: '系統設置',
//     icon: 'lnr.lnr-cog',
//     regex: /\/account/,
//     auth: '系統設置'
// },
// {
//     href: '/service',
//     title: '服務條款',
//     icon: 'lnr.lnr-bullhorn',
//     regex: /\/service/,
//     auth: '服務條款'
// },
// {
//     href: '/faq',
//     title: '問與答',
//     icon: 'lnr.lnr-question-circle',
//     regex: /\/faq/,
//     auth: '問與答'
// },



